var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03754 2.04019L8.02891 1.37588H7.3646C7.31819 1.37544 7.27179 1.37544 7.22538 1.37588C3.20073 1.41431 -0.0307739 4.70813 0.00766359 8.73278C0.0461011 12.7575 3.33991 15.9889 7.36457 15.9505C11.3874 15.9461 14.6474 12.6863 14.6522 8.66353V7.99922H8.02891L8.03754 2.04019Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37012 0.0491943V6.67185H15.9921C15.975 3.02163 13.0203 0.0666631 9.37012 0.0491943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.904c4926b573b136b4a31082c226d60c.svg";
export { ForwardRef as ReactComponent };